import styled from 'styled-components'
import { SPACING, BORDER_RADIUS } from '../../../styles/theme'
import { SkeletonBox } from '../styles/SkeletonStyles'

const Canvas = styled.div`
  position: relative;
  width: 100%;
  height: calc(100dvh - 64px);
  overflow: hidden;
  background-color: var(--color-bg-primary);
  background-image: radial-gradient(circle, var(--color-border-dark) 1px, transparent 1px);
  background-size: 24px 24px;
`

const ControlsOverlay = styled.div`
  position: absolute;
  inset: ${SPACING.lg};
  z-index: 10;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  pointer-events: none;
`

const LeftControls = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`

const RightControls = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.sm};
`

export function SkeletonMindmap() {
  return (
    <Canvas>
      <ControlsOverlay>
        <LeftControls>
          <SkeletonBox $width="220px" $height="36px" $radius={BORDER_RADIUS.xl} />
          <SkeletonBox $width="182px" $height="36px" $radius={BORDER_RADIUS.xl} />
        </LeftControls>
        <RightControls>
          {[90, 96, 40, 40, 40, 116, 40].map((w, i) => (
            <SkeletonBox key={i} $width={`${w}px`} $height="40px" $radius={BORDER_RADIUS.xl} />
          ))}
        </RightControls>
      </ControlsOverlay>
    </Canvas>
  )
}
